import { tv } from "@pcln/horizon";
const aiSearchInput = tv({
    slots: {
        root: [
            'relative isolate flex w-full flex-col rounded-3xl bg-neutral-1 p-3 shadow-penny-sm',
            'focus-within:ring-0 focus-within:outline-none'
        ],
        content: 'relative flex w-full flex-none flex-col gap-4',
        inputWrapper: 'relative min-w-0 flex-1 px-2 @xl:px-0',
        textarea: [
            'block w-full resize-none border-0 bg-transparent text-body1 font-medium text-neutral-13',
            'focus:ring-0 focus:outline-none',
            '@xl:pl-2'
        ],
        placeholderOverlay: [
            'pointer-events-none absolute inset-0 overflow-hidden text-body1 font-medium whitespace-pre-wrap text-neutral-10',
            'px-2 @xl:px-0 @xl:pl-2'
        ],
        footer: 'flex w-full shrink-0 items-center justify-end',
        submitButton: 'self-end'
    },
    variants: {
        isMultiLine: {
            false: {
                content: '@xl:flex-row @xl:items-center @xl:gap-2',
                footer: '@xl:w-fit'
            },
            true: {
                root: 'pt-6 pb-4',
                inputWrapper: 'w-full px-2'
            }
        },
        disabled: {
            true: {
                textarea: 'cursor-not-allowed'
            }
        }
    },
    defaultVariants: {
        isMultiLine: false,
        disabled: false
    }
});
export { aiSearchInput };
